import { Reveal } from '@/components/ui/Reveal'

import { SectionLabel } from './HowItWorks'

const features = [
  {
    desc: "Slot data updates live across all venues. What you see is exactly what's available right now — no stale info, no surprises.",
    icon: '⚡',
    title: 'Real-time Availability',
  },
  {
    desc: 'UPI, debit, credit card, and popular wallets supported. Booking confirmed in seconds with a digital receipt sent to WhatsApp.',
    icon: '💳',
    title: 'Instant Payments',
  },
  {
    desc: 'Track bookings, revenue, slot utilization, and customer insights in one clean, powerful dashboard.',
    icon: '📊',
    title: 'Owner Dashboard',
  },
  {
    desc: 'Players get instant booking confirmations. Owners get real-time alerts for every new reservation — no app needed.',
    icon: '📱',
    title: 'WhatsApp & SMS Alerts',
  },
  {
    desc: "Only players who've actually booked can leave reviews. Honest ratings that help others choose the best turf.",
    icon: '⭐',
    title: 'Verified Reviews',
  },
  {
    desc: 'Teams lock in weekly slots in advance. Owners get predictable revenue and fewer last-minute cancellations.',
    icon: '🔁',
    title: 'Recurring Bookings',
  },
]

export function Features() {
  return (
    <section
      className="py-20"
      style={{
        background: 'var(--bg2)',
        borderBottom: '1px solid var(--lime-line)',
        borderTop: '1px solid var(--lime-line)',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionLabel>Platform features</SectionLabel>
        <Reveal delay={0.05}>
          <h2
            className="font-display font-bold leading-[1.1] tracking-tight mb-12"
            style={{
              color: 'var(--text)',
              fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
              letterSpacing: '-.5px',
              maxWidth: 520,
            }}
          >
            Everything players and owners need
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <Reveal delay={i * 0.07} key={f.title}>
              <div
                className="relative rounded-2xl p-7 overflow-hidden transition-all duration-200 hover:-translate-y-0.5 h-full"
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = 'rgba(184,236,60,.4)')}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'var(--lime-line)')}
                style={{ background: 'var(--bg3)', border: '1px solid var(--lime-line)' }}
              >
                {/* Top accent line */}
                <div
                  className="absolute top-0 left-0 right-0 h-0.5"
                  style={{ background: 'linear-gradient(90deg,var(--lime),transparent)' }}
                />
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center text-[1.15rem] mb-5"
                  style={{ background: 'var(--lime-dim)' }}
                >
                  {f.icon}
                </div>
                <div className="font-semibold text-[0.95rem] mb-2" style={{ color: 'var(--text)' }}>
                  {f.title}
                </div>
                <div
                  className="text-[0.82rem] font-light leading-relaxed"
                  style={{ color: 'var(--muted)' }}
                >
                  {f.desc}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
